

import app from "@/main";
import { AuthService, UserService } from "../services";

const actions = {
  async login({ commit }, { username, password }) {
    const { user, token } = await AuthService.login({ username, password });
    AuthService.authenticateUser(user, token);
    
    commit("storeUser", user, { root: true });
  },
  async getUserInfo({ commit }) {
    const { profile } = await UserService.getProfile();
    commit("updateUser", profile, { root: true });
  },
  async register(
    { commit },
    { firstname, lastname, email, phonenumber, password, referrerscode }
  ) {
    const { user, token } = await AuthService.register({
      firstname,
      lastname,
      email,
      phonenumber,
      password,
      referrerscode
    });
    AuthService.authenticateUser(user, token);
    commit("storeUser", user, { root: true });
  },
  async logout({ commit }, { reRoute = true } = {}) {
    localStorage.clear();
    commit("removeUser", null, { root: true });
    if (reRoute) app.$router.replace({ name: "login" });
  }
};

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions
};
